var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.challengeLocked)?_c('div',{staticClass:"lock-message"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.unlockMessage)}})]):_c('narrative-player',{attrs:{"narratives":_vm.narratives,"on-complete":_vm.onComplete}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad769514","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/pages/ChallengeIntro.vue
// module id = null
// module chunks = 